// extracted by mini-css-extract-plugin
export default {"ColorPalette":"styles_ColorPalette__lk5Hh","colorPickerContainer":"styles_colorPickerContainer__RzGBV","colorInfoContainer":"styles_colorInfoContainer__DnFCS"};